

export default () => {
  $(".owl-blogs-slider").owlCarousel({
    stagePadding: 10,
    center: false,
    loop: false,
    nav: true,
    navText: ["<i class='fal fa-chevron-left'></i>","<i class='fal fa-chevron-right'></i>"],
    responsive:{
      0: {
        items: 2
      },
      768: {
        items: 4,
        margin: 15,
      },
      1040: {
        items: 4,
        margin: 0
      }
    }
  });

  $('.owl-authors[data-id=A]').removeClass('hidden');

  $(".authors-slider").find(".letter").on("click", function(){
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    $('.owl-authors').addClass('hidden');
    $('.owl-authors[data-id=' + $(this).attr('data-id') + ']').removeClass('hidden');
  });
}
